import React from 'react'
import { LearnMoreLink } from 'src/components/Reusable/Text/Link'
import { IndexPageActionsContainer } from '../PageLayout.styles'

export const IndexPageActions = ({
  description,
  learnMoreUrl,
  buttonGroup,
}: {
  description: string
  learnMoreUrl?: string
  buttonGroup?: React.ReactNode
}): JSX.Element => {
  return (
    <IndexPageActionsContainer>
      <div>
        {description} {learnMoreUrl && <LearnMoreLink href={learnMoreUrl} />}
      </div>
      {buttonGroup}
    </IndexPageActionsContainer>
  )
}
